<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 4; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn overflow-hidden">
      <div
        class="
          asc-page-heading
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div>Dashboard</div>
      </div>
      <div class="panLog-main-class">
        <div class="relativeclass">
          <div class="pan-log-tabs">
            <b-tabs content-class="mt-1 position-relative" v-model="tabIndex">
              <div
                class="fil-btn-pos"
                v-if="
                  shouldShowProvideFeedback ||
                  shouldShowScheduledFeedback ||
                  shouldShowScreenTab
                "
              >
                <div
                  @click="
                    tabIndex === 2
                      ? openFilter()
                      : (showfiltercard = !showfiltercard),
                      filtercount === 0 ? clearfilter() : null
                  "
                  class="d-flex relativeclass addpan"
                >
                  <b-button class="mr-3" ref="filterButton">
                    <img
                      src="../../assets/panelist/filter_pan.svg"
                      alt=""
                      class="ml-2"
                    />
                    <span class="addpantxt mr-2">Filter</span>
                  </b-button>
                  <div
                    class="mb-3 pointer"
                    style="position: absolute; top: -3px; left: 30px"
                    v-if="filtercount != 0 || screenFilterCount !== 0"
                  >
                    <img src="../../assets/panelist/fil_selected.svg" alt="" />
                  </div>
                </div>
                <div>
                  <div
                    v-if="showfiltercard"
                    ref="filtercard"
                    class="panelist-filtercard"
                    style="top: 34px; right: 18px; width: 300px"
                    :style="
                      tabIndex === 2 ? 'height: 140px' : 'min-height: 289px'
                    "
                  >
                    <template v-if="tabIndex !== 2">
                      <div
                        style="width: 270px"
                        class="aoeskl-field topDiv panelist-tags"
                        @click.stop=""
                      >
                        <label class="teams-label-font">Job Name:</label>
                        <b-form-input
                          class="text-truncate filter-fields"
                          id="input-1"
                          placeholder="Enter"
                          v-model="jobname"
                        >
                        </b-form-input>
                      </div>
                      <div
                        class="tags-with-addBtn topDiv mt-3 mb-2"
                        style="width: 270px"
                        @click.stop=""
                      >
                        <label class="teams-label-font">Skills:</label>
                        <b-form-tags
                          class="text-truncate filter-fields"
                          id="input-1"
                          :tag-validator="tagValidatorskill"
                          placeholder="Enter"
                          v-model="skills"
                          remove-on-delete
                        >
                        </b-form-tags>
                        <span class="panelskills-text ml-1">
                          Press enter to separate Skills
                        </span>
                      </div>
                      <div class="topDiv mb-2" @click.stop="">
                        <MultiSelectCustom
                          :label="'Round:'"
                          :values="transformedRounds"
                          :placeholder="'Select'"
                          :id="'PanelRounds'"
                          :dropdown="true"
                          :vmodel="selectedValue"
                          @select-value="selectedValue = $event"
                        />
                      </div>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          mt-3
                          bluebtn
                        "
                      >
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="(showfiltercard = false), clearfilter()"
                        >
                          Cancel
                        </b-button>

                        <div class="d-flex">
                          <b-button
                            class="acs-cancelBtn-filter mr-2"
                            :disabled="filtercount == 0"
                            @click="clearfilter(), (showfiltercard = false)"
                          >
                            Reset
                          </b-button>
                          <b-button
                            class="pointer acs-cancelBtn-filter"
                            :disabled="
                              jobname == '' &&
                              skills.length == 0 &&
                              selectedValue.length == 0
                            "
                            @click="applyFilterCard()"
                          >
                            Apply
                          </b-button>
                        </div>
                      </div>
                    </template>

                    <template v-else>
                      <div class="position-relative">
                        <selectCustom
                          placeholder="Status"
                          label="Status"
                          :dropdown="true"
                          :values="status"
                          type="filter"
                          :vmodel="filterStatus"
                          @select-value="(data) => (filterStatus = data)"
                        />
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                            mt-3
                            bluebtn
                          "
                        >
                          <b-button
                            class="acs-cancelBtn-filter"
                            @click="showfiltercard = false"
                          >
                            Cancel
                          </b-button>

                          <div class="d-flex">
                            <b-button
                              class="acs-cancelBtn-filter mr-2"
                              :disabled="
                                filterStatus == '' && screenFilterCount
                              "
                              @click="clear"
                            >
                              Reset
                            </b-button>
                            <b-button
                              class="pointer acs-cancelBtn-filter"
                              @click="applyFilter"
                            >
                              Apply
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <b-tab
                title="Scheduled"
                @click="
                  (statusValue = 'createdAt'),
                    (sortByValue = false),
                    (feedbackValue = 'false'),
                    (goToPage = null),
                    (currentPage = 1),
                    (showfiltercard = false),
                    clearfilter(),
                    getAllPanelCandidate()
                "
              >
                <div v-if="tabIndex == 0" class="pan-log-tab"></div>
                <div
                  v-if="
                    feebackScheduledCandidate.length == 0 &&
                    searchQuery == '' &&
                    filtercount == 0 &&
                    !LoaderStatus
                  "
                >
                  <div
                    class="d-flex justify-content-center align-items-center"
                    style="height: calc(100vh - 233px)"
                  >
                    <div>
                      <div><img src="../../assets/panelLog/no_scd.svg" /></div>
                      <div class="notfoundimg ml-4">
                        There are no interviews scheduled with you.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="height: calc(100vh - 233px)"
                  v-else-if="
                    feebackScheduledCandidate.length == 0 &&
                    searchQuery != '' &&
                    !LoaderStatus &&
                    searchQuery != 'Loader'
                  "
                >
                  <div
                    class="
                      d-flex
                      justify-content-center
                      align-items-center
                      flex-column
                    "
                  >
                    <div>
                      <img src="../../assets/panelLog/searchnotfoundpan.svg" />
                    </div>
                    <div class="notfoundimg mt-3">
                      No matching results for "{{ searchQuery }}"
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="
                    feebackScheduledCandidate.length == 0 && filtercount != 0
                  "
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <div
                      class="
                        mt-5
                        pt-4
                        d-flex
                        justify-content-center
                        align-items-center
                        flex-column
                      "
                    >
                      <div>
                        <img src="../../assets/panelLog/norecordspan.svg" />
                      </div>
                      <div class="notfoundimg ml-2 mt-3">No records found</div>
                    </div>
                  </div>
                </div>

                <!-- new table design starts from here -->
                <div v-else class="new-panelCand-main-table" id="scrollToUser">
                  <div
                    class="resumescreening-table-head new-panelCand-table-head"
                  >
                    <div style="width: 12%" class="d-flex pl-3">
                      Candidate Name

                      <div v-if="statusValue == 'candidate.name'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.name'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.name'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </div>
                      <div v-else>
                        <img
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.name'),
                              (sortByValue = true),
                              (feedbackValue = 'false'),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/nosort.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div style="width: 12%" class="text-left">
                      <span>Email ID</span>
                      <template v-if="statusValue == 'candidate.email'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.email'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.email'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'candidate.email'),
                            (sortByValue = true),
                            (feedbackValue = 'false'),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 10%" class="text-left">
                      <span>Contact Number</span>
                    </div>
                    <div style="width: 11%" class="text-left">
                      <span>Skills</span>
                    </div>
                    <div style="width: 10%" class="text-left">
                      <span>Job Name</span>
                      <template v-if="statusValue == 'job.title'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'job.title'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'job.title'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'job.title'),
                            (sortByValue = true),
                            (feedbackValue = 'false'),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 18%" class="text-left">
                      <span>Interview Timing</span>
                      <template v-if="statusValue == 'startTime'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'startTime'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'startTime'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'startTime'),
                            (sortByValue = true),
                            (feedbackValue = 'false'),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 5%" class="text-left">
                      <span>Rounds</span>
                    </div>
                    <div style="width: 10%" class="text-center">Actions</div>
                    <div style="width: 12%" class="text-left"></div>
                  </div>
                  <div
                    class="resume-screening-table-body new-panelCand-table-body"
                  >
                    <template>
                      <div
                        class="
                          resume-screening-table-row
                          new-panelCand-table-row
                          d-flex
                          align-items-center
                        "
                        v-for="(cand, i) in feebackScheduledCandidate"
                        :id="i + 'top'"
                        :key="i"
                      >
                        <div class="gridgreencolorDynamic-user"></div>

                        <div
                          style="width: 12%"
                          class="relativeclass pr-2 pl-3 pt-1"
                        >
                          <span
                            style="max-width: 100%"
                            class="text-truncate d-inline-block"
                            v-b-popover.hover.top="cand.candidate.name"
                          >
                            {{ cand.candidate.name }}
                          </span>
                        </div>
                        <div style="width: 12%" class="text-left pt-1 pr-2">
                          <span
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                            v-b-popover.hover.top="cand.candidate.email"
                          >
                            {{ cand.candidate.email }}
                          </span>
                        </div>
                        <div style="width: 10%" class="text-left pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 100%"
                          >
                            {{ cand.candidate.phoneNumber }}
                          </span>
                        </div>
                        <div style="width: 11%" class="text-left pr-2 pt-1">
                          <span
                            style="max-width: 100%"
                            :id="'pc1' + cand.interviewID"
                            class="defaultCursor text-truncate d-inline-block"
                          >
                            {{ cand.candidateSkills.join(", ") }}
                          </span>
                          <span>
                            <b-popover
                              :target="'pc1' + cand.interviewID"
                              triggers="hover"
                              placement="top"
                            >
                              {{ cand.candidateSkills.join(", ") }}
                            </b-popover>
                          </span>
                        </div>
                        <div
                          style="width: 10%"
                          class="text-left defaultCursor pr-2 pt-1"
                        >
                          <span
                            v-b-popover.hover.bottom="cand.jobName"
                            class="d-inline-block text-truncate"
                            style="max-width: 100%"
                          >
                            {{ cand.jobName }}</span
                          >
                        </div>
                        <div style="width: 18%" class="text-left pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                            v-b-popover.hover.bottom="cand.startTimeFormatted"
                          >
                            {{ cand.startTimeFormatted }}
                          </span>
                        </div>
                        <div style="width: 5%" class="text-left pt-1">
                          <span class="d-inline-block text-truncate">
                            {{ cand.interviewRound.roundOfrounds }}</span
                          >
                        </div>
                        <div style="width: 10%" class="text-center pt-1">
                          <!--***********   Uncomment according to condition   ***********-->
                          <span class="d-inline-block text-truncate">
                            <img
                              class="mr-3 pointer"
                              @click="history(cand)"
                              v-b-popover.hover.top="'Feedback History'"
                              src="../../assets/panelLog/viewfeedback.svg"
                              alt=""
                            />
                            <img
                              v-if="cand.showJdIcon"
                              class="mr-3 pointer"
                              @click="getPanelJdDetails(cand)"
                              v-b-popover.hover.top="'Job Details'"
                              src="../../assets/panelLog/JD approval.svg"
                              alt=""
                            />
                            <img
                              v-else
                              class="mr-4"
                              src="../../assets/panelLog/blue-dash.svg"
                              alt=""
                            />

                            <img
                              @click="exportResume(cand.candidate)"
                              class="pointer"
                              v-b-popover.hover.top="'Download Resume'"
                              src="../../assets/panelLog/downloadres.svg"
                              alt=""
                            />
                            <img
                              class="pointer ml-2"
                              v-b-popover.hover.top="'Join Meeting'"
                              src="../../assets/panelLog/join-meet.svg"
                              alt=""
                              @click="navigateToLink(cand)"
                            />
                          </span>
                        </div>
                        <div style="width: 12%" class="text-left">
                          <div
                            @click="getfeedbackforms(cand, i)"
                            class="addpan pointer pl-40"
                          >
                            <b-button>
                              <img
                                src="../../assets/panelist/plus_pan.svg"
                                alt=""
                                class="ml-2"
                              />
                              <span class="addpantxt mr-2">Feedback</span>
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="
                      new-panelCand-admin-paginaTion-new
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="d-flex">
                      <span class="qb-gotopage-text p-2">Go to page</span>
                      <b-form-input
                        type="text"
                        class="qb-pagination-num ml-2 mt-1"
                        v-model="goToPage"
                        @keyup.enter="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages(goToPage)
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>

                      <span
                        @click="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages(goToPage)
                        "
                        :class="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? 'disableDeleteIcon pl-3 mt-1'
                            : 'pointer pl-3 mt-1'
                        "
                        ><img src="../../assets/panelist/page_arrow.svg" alt=""
                      /></span>
                    </div>
                    <div class="pagination">
                      <b-pagination
                        class="page_text"
                        v-model.number="currentPage"
                        @input="getAllPanelCandidate()"
                        :total-rows="total"
                        :per-page="pageCount"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_left.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_right.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex justify-content-between">
                      <PageInput
                        :pagecount="pageCount"
                        @update-value="updatePage"
                      />
                      <div class="qb-gotopage-text mr-2 ml-3">
                        Showing : <span v-if="pageStart > total">0</span
                        ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                        <span class="pl-1"></span> of <span class="pr-1"></span
                        >{{ total }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                title="Feedback Provided"
                @click="
                  (statusValue = 'updatedAt'),
                    (sortByValue = false),
                    (feedbackValue = 'true'),
                    (goToPage = null),
                    (currentPage = 1),
                    (showfiltercard = false),
                    clearfilter(),
                    getAllPanelCandidate()
                "
              >
                <div v-if="tabIndex == 1" class="pan-log-fp-tab"></div>
                <!-- new table design starts from here -->
                <div
                  v-if="
                    feebackProvideCandidate.length == 0 &&
                    searchQuery == '' &&
                    filtercount == 0 &&
                    !LoaderStatus
                  "
                >
                  <div
                    class="d-flex justify-content-center align-items-center"
                    style="height: calc(100vh - 233px)"
                  >
                    <div>
                      <div><img src="../../assets/panelLog/no_scd.svg" /></div>
                      <div class="text-center notfoundimg ml-2">
                        There is no feedback provided.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="height: calc(100vh - 233px)"
                  v-else-if="
                    feebackProvideCandidate.length == 0 &&
                    searchQuery != '' &&
                    !LoaderStatus &&
                    searchQuery != 'Loader'
                  "
                >
                  <div
                    class="
                      d-flex
                      justify-content-center
                      align-items-center
                      flex-column
                    "
                  >
                    <div>
                      <img src="../../assets/panelLog/searchnotfoundpan.svg" />
                    </div>
                    <div class="notfoundimg mt-3">
                      No matching results for "{{ searchQuery }}"
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="
                    feebackProvideCandidate.length == 0 && filtercount != 0
                  "
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="mt-5 pt-4">
                      <div>
                        <img src="../../assets/panelLog/norecordspan.svg" />
                      </div>
                      <div class="notfoundimg text-center mt-3">
                        No records found
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="new-panelCand-main-table">
                  <div
                    class="resumescreening-table-head new-panelCand-table-head"
                  >
                    <div style="width: 16%" class="text-left pl-3">
                      <span>Candidate Name</span>
                      <template v-if="statusValue == 'candidate.name'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.name'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.name'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'candidate.name'),
                            (sortByValue = true),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 12%" class="text-left">
                      <span>Email ID</span>
                      <template v-if="statusValue == 'candidate.email'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.email'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'candidate.email'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'candidate.email'),
                            (sortByValue = true),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 10%" class="text-left">
                      <span>Contact Number</span>
                    </div>
                    <div style="width: 12%" class="text-left">
                      <span>Skills</span>
                    </div>
                    <div style="width: 15%" class="text-left">
                      <span>Job Name</span>
                      <template v-if="statusValue == 'job.title'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'job.title'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'job.title'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'job.title'),
                            (sortByValue = true),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 17%" class="text-left">
                      <span>Interview Timing</span>
                      <template v-if="statusValue == 'startTime'">
                        <img
                          v-if="sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'startTime'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue"
                          class="pointer ml-2"
                          @click="
                            (statusValue = 'startTime'),
                              (sortByValue = !sortByValue),
                              getAllPanelCandidate()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (statusValue = 'startTime'),
                            (sortByValue = true),
                            getAllPanelCandidate()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 3%" class="text-left">
                      <span>Rounds</span>
                    </div>
                    <div style="width: 15%" class="text-center">Actions</div>
                  </div>
                  <div
                    class="resume-screening-table-body new-panelCand-table-body"
                  >
                    <template>
                      <div
                        class="
                          resume-screening-table-row
                          new-panelCand-table-row
                          d-flex
                          align-items-center
                        "
                        v-for="(cand, index) in feebackProvideCandidate"
                        :key="index"
                        :id="index + 'top'"
                      >
                        <div class="gridgreencolorDynamic-user"></div>

                        <div
                          style="width: 16%"
                          class="relativeclass text-left pt-1 pl-3 pr-2"
                        >
                          <span
                            class="text-truncate d-inline-block"
                            style="min-width: auto; max-width: 100%"
                            v-b-popover.hover.top="cand.candidate.name"
                          >
                            {{ cand.candidate.name }}
                          </span>
                        </div>
                        <div style="width: 12%" class="text-left pt-1 pr-2">
                          <span
                            v-b-popover.hover.top="cand.candidate.email"
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                          >
                            {{ cand.candidate.email }}
                          </span>
                        </div>
                        <div style="width: 10%" class="text-left pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                          >
                            {{ cand.candidate.phoneNumber }}
                          </span>
                        </div>
                        <div style="width: 12%" class="text-left pt-1 pr-2">
                          <span
                            style="min-width: auto; max-width: 100%"
                            :id="'pc2' + cand.interviewID"
                            class="defaultCursor text-truncate d-inline-block"
                          >
                            {{ cand.candidateSkills.join(", ") }}
                          </span>
                          <span>
                            <b-popover
                              :target="'pc2' + cand.interviewID"
                              triggers="hover"
                              placement="top"
                            >
                              {{ cand.candidateSkills.join(", ") }}
                            </b-popover>
                          </span>
                        </div>
                        <div
                          style="width: 15%"
                          class="text-left defaultCursor pt-1 pr-2"
                        >
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 100%"
                            v-b-popover.hover.bottom="cand.jobName"
                            >{{ cand.jobName }}</span
                          >
                        </div>
                        <div style="width: 17%" class="text-left pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                          >
                            {{ cand.startTimeFormatted }}
                          </span>
                        </div>
                        <div style="width: 3%" class="text-left pt-1">
                          <span class="d-inline-block text-truncate">
                            {{ cand.interviewRound.roundOfrounds }}</span
                          >
                        </div>
                        <div style="width: 15%" class="text-center pt-1">
                          <span class="d-inline-block text-truncate">
                            <img
                              class="mr-3 pointer"
                              @click="history(cand)"
                              v-b-popover.hover.top="'Feedback History'"
                              src="../../assets/panelLog/viewfeedback.svg"
                              alt=""
                            />
                            <img
                              v-if="cand.showJdIcon"
                              class="mr-3 pointer"
                              @click="getPanelJdDetails(cand)"
                              v-b-popover.hover.top="'Job Details'"
                              src="../../assets/panelLog/JD approval.svg"
                              alt=""
                            />
                            <img
                              v-else
                              class="mr-4"
                              src="../../assets/panelLog/blue-dash.svg"
                              alt=""
                            />

                            <img
                              @click="exportResume(cand.candidate)"
                              class="pointer"
                              v-b-popover.hover.top="'Download Resume'"
                              src="../../assets/panelLog/downloadres.svg"
                              alt=""
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div
                    class="
                      new-panelCand-admin-paginaTion-new
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="d-flex">
                      <span class="qb-gotopage-text p-2">Go to page</span>
                      <b-form-input
                        type="text"
                        class="qb-pagination-num ml-2 mt-1"
                        v-model="goToPage"
                        @keyup.enter="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages(goToPage)
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>

                      <span
                        @click="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages(goToPage)
                        "
                        :class="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? 'disableDeleteIcon pl-3 mt-1'
                            : 'pointer pl-3 mt-1'
                        "
                        ><img src="../../assets/panelist/page_arrow.svg" alt=""
                      /></span>
                    </div>
                    <div class="pagination">
                      <b-pagination
                        class="page_text"
                        v-model.number="currentPage"
                        @input="getAllPanelCandidate()"
                        :total-rows="total"
                        :per-page="pageCount"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_left.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_right.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex justify-content-between">
                      <PageInput
                        :pagecount="pageCount"
                        @update-value="updatePage"
                      />
                      <div class="qb-gotopage-text mr-2 ml-3">
                        Showing : <span v-if="pageStart > total">0</span
                        ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                        <span class="pl-1"></span> of <span class="pr-1"></span
                        >{{ total }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>

              <b-tab
                v-if="roles.includes('PROFILE_SCREENING')"
                title="Resume Screening"
                @click="
                  (sortBy = 'createdAt'),
                    (sortOrder = -1),
                    (goToScreen = null),
                    (screenPage = 1),
                    clearfilter(),
                    fetchScreeningData()
                "
              >
                <div
                  v-if="tabIndex == 2"
                  class="pan-log-fp-tab"
                  style="left: 300px"
                ></div>
                <!-- new table design starts from here -->
                <div
                  v-if="
                    screeningCandidates.length == 0 &&
                    searchQuery.length &&
                    searchQuery != 'Loader' &&
                    !LoaderStatus
                  "
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="mt-5 pt-4">
                      <div>
                        <img src="../../assets/panelLog/norecordspan.svg" />
                      </div>
                      <div class="notfoundimg text-center mt-3">
                        No Matching results for "{{ searchQuery }}"
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="
                    screeningCandidates.length === 0 &&
                    !LoaderStatus &&
                    searchQuery != 'Loader'
                  "
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="mt-5 pt-4">
                      <div><img src="../../assets/panelLog/no_scd.svg" /></div>
                      <div class="text-center notfoundimg ml-2">
                        No Candidates
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="new-panelCand-main-table p-0">
                  <div
                    class="resumescreening-table-head new-panelCand-table-head"
                    style=""
                  >
                    <div style="width: 20%" class="pl-3">
                      <span>Candidate Name</span>
                      <template v-if="sortBy == 'candidate.name'">
                        <img
                          v-if="sortOrder === -1"
                          class="pointer ml-2"
                          @click="
                            (sortBy = 'candidate.name'),
                              (sortOrder = 1),
                              fetchScreeningData()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                        <img
                          v-if="sortOrder === 1"
                          class="pointer ml-2"
                          @click="
                            (sortBy = 'candidate.name'),
                              (sortOrder = -1),
                              fetchScreeningData()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (sortBy = 'candidate.name'),
                            (sortOrder = 1),
                            fetchScreeningData()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 20%" class="text-left">
                      <span>Email ID</span>
                      <template v-if="sortBy == 'candidate.email'">
                        <img
                          v-if="sortOrder === -1"
                          class="pointer ml-2"
                          @click="
                            (sortBy = 'candidate.email'),
                              (sortOrder = 1),
                              fetchScreeningData()
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                        <img
                          v-if="sortOrder === 1"
                          class="pointer ml-2"
                          @click="
                            (sortBy = 'candidate.email'),
                              (sortOrder = -1),
                              fetchScreeningData()
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        v-else
                        class="pointer ml-2"
                        @click="
                          (sortBy = 'candidate.email'),
                            (sortOrder = 1),
                            fetchScreeningData()
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 10%" class="text-left">
                      <span>Contact Number</span>
                    </div>
                    <div style="width: 20%" class="text-left">
                      <span>Skills</span>
                    </div>
                    <div style="width: 20%" class="text-left">
                      <span>Job Name</span>
                    </div>
                    <div style="width: 10%" class="text-center"></div>
                  </div>
                  <div
                    class="
                      overflow-xh-ya
                      resume-screening-table-body
                      new-panelCand-table-body
                    "
                  >
                    <template>
                      <div
                        class="
                          resume-screening-table-row
                          new-panelCand-table-row
                          d-flex
                          align-items-center
                        "
                        v-for="(cand, index) in screeningCandidates"
                        :key="index"
                        :id="index + 'top'"
                        style=""
                      >
                        <div class="gridgreencolorDynamic-user"></div>

                        <div
                          style="width: 20%"
                          class="relativeclass pl-3 pt-1 pr-2"
                        >
                          <span
                            class="text-truncate d-inline-block"
                            style="max-width: 100%"
                            v-b-popover.hover.top="cand.candidate.name"
                          >
                            {{ cand.candidate.name }}
                          </span>
                        </div>
                        <div style="width: 20%" class="pr-2 pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 100%"
                            v-b-popover.hover.top="cand.candidate.email"
                          >
                            {{ cand.candidate.email }}
                          </span>
                        </div>
                        <div style="width: 10%" class="pt-1">
                          <span
                            class="d-inline-block text-truncate"
                            style="min-width: auto; max-width: 100%"
                          >
                            {{ cand.candidate.phoneNumber }}
                          </span>
                        </div>
                        <div style="width: 20%" class="pr-2 pt-1">
                          <span
                            style="max-width: 100%"
                            :id="'pc2' + cand.candidateID"
                            class="defaultCursor d-inline-block text-truncate"
                          >
                            <!-- fnName -->
                            {{ cand.candidate.skills.join(", ") }}
                          </span>
                          <span>
                            <b-popover
                              :target="'pc2' + cand.candidate.candidateID"
                              triggers="hover"
                              placement="top"
                            >
                              {{ cand.candidate.skills.join(", ") }}
                            </b-popover>
                          </span>
                        </div>
                        <div style="width: 20%" class="defaultCursor pr-2 pt-1">
                          <span
                            v-b-popover.hover.bottom="
                              cand.jobID ? cand.jobData.title : ''
                            "
                            style="max-width: 100%"
                            class="d-inline-block text-truncate"
                          >
                            {{ cand.jobID ? cand.jobData.title : "-" }}
                          </span>
                        </div>
                        <div style="width: 10%" class="text-left">
                          <div
                            @click="
                              $router.push({
                                name: 'GiveFeedback',
                                params: {
                                  id: cand._id,
                                },
                                query: {
                                  feedbacktype: showRecOptions,
                                  candidateId: cand.candidateID,
                                },
                              })
                            "
                            class="addpan pointer"
                          >
                            <b-button class="widthhundredpx-125">
                              <img
                                v-if="!cand.submitted"
                                src="../../assets/panelist/plus_pan.svg"
                                alt=""
                                class=""
                              />
                              <span class="addpantxt">{{
                                !cand.submitted ? "Feedback" : "View Feedback"
                              }}</span>
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>

                  <div
                    class="
                      new-panelCand-admin-paginaTion-new
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                  >
                    <div class="d-flex">
                      <span class="qb-gotopage-text p-2">Go to page</span>
                      <b-form-input
                        type="text"
                        class="qb-pagination-num ml-2 mt-1"
                        v-model="goToScreen"
                        @keyup.enter="
                          goToPage === null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToScreenPage(goToScreen)
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>

                      <span
                        @click="
                          goToScreen === null ||
                          goToScreen == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToScreenPage(goToScreen)
                        "
                        :class="
                          goToScreen === null ||
                          goToScreen == '' ||
                          !iscontainsNumber
                            ? 'disableDeleteIcon pl-3 mt-1'
                            : 'pointer pl-3 mt-1'
                        "
                        ><img src="../../assets/panelist/page_arrow.svg" alt=""
                      /></span>
                    </div>
                    <div class="pagination">
                      <b-pagination
                        class="page_text"
                        v-model.number="screenPage"
                        @input="fetchScreeningData"
                        :total-rows="total"
                        :per-page="pageCount"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_left.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/panelist/page_right.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex justify-content-between">
                      <PageInput
                        :pagecount="pageCount"
                        @update-value="updateScreenPage"
                      />
                      <div class="qb-gotopage-text mr-2 ml-3">
                        Showing : <span v-if="pageStart > total">0</span
                        ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                        <span class="pl-1"></span> of <span class="pr-1"></span
                        >{{ total }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- feedback form starts-->

    <!-- feedback form ends-->
    <!-- **************************** HISTORY MODAL START ****************************************  -->

    <!-- ***********************view fill feedback modal start *********************** -->

    <ViewFeedback :context="this" />

    <JobDetails
      v-if="showBasicDetailsJD"
      :showBasicDetailsJD="showBasicDetailsJD"
      :panelJdDetails="panelJdDetails"
      @hideBasicJobDetailsModal="hideBasicJobDetailsModal"
    />

    <AllJobDetails
      v-if="showAllDetailsJD"
      :showAllDetailsJD="showAllDetailsJD"
      :panelJdDetails="panelJdDetails"
      :allDetailDropDowns="allDetailDropDowns"
      @hideAllJobDetailsModal="hideAllJobDetailsModal"
      :jdDetailsType="jdDetailsType"
      :basicArray="basicArray"
      :advanceArray="advanceArray"
    />

    <LastRoundFeedback
      :viewfeedback="viewfeedback"
      :feedback="feedback"
      :interviewObject="interviewObject"
      :interviewCandidate="interviewCandidate"
      :interviewResponse="interviewResponse"
      :selectedCandidate="selectedCandidate"
      @storeCandidateData="storeCandidateData"
      @giveLastFdbck="getAllPanelCandidate"
      :panelName="panelName"
      :evalDate="evalDate"
    />

    <GiveFeedback
      :basicCandInfo="candidateDetails"
      :viewfeedback="viewfeedback"
      :feedback="feedback"
      :interviewObject="interviewObject"
      :interviewResponse="interviewResponse"
      :interviewCandidate="interviewCandidate"
      :panelName="panelName"
      :feedbackform="feedbackform"
      :uploadcandheight="uploadcandheight"
      :selectedCandidate="selectedCandidate"
      :allpaneldata="allpaneldata"
      :showfeedbackSpinner="showfeedbackSpinner"
      @giveLastFdbck="getAllPanelCandidate"
      @storeCandidateData="storeCandidateData"
      :evalDate="evalDate"
    />
    <History
      v-if="showModal"
      :showModal="showModal"
      :feedbackHistory="feedbackHistory"
      :selectedCandidate="selectedCandidate"
      @hideFeedbackhistory="hideFeedbackhistory"
      @storeCandidateData="storeCandidateData"
      :showSpinner="showSpinner"
    />

    <!-- ************View fill feedback modal end ************* -->
    <b-modal id="totalmark" centered hide-footer hide-header @hidden="closeMarksModal()">
      <div class="total-marks-box">
        <div
          class="
            viewmark-heading
            pl-2
            pr-2
            pt-3
            pb-3
            d-flex
            align-items-center
            justify-content-between
          "
        >
          View Marks
        </div>
        <div class="xMarkCancel" @click="closeMarksModal()">
          <img src="../../assets/xmark.svg" alt="" />
        </div>
        <hr class="m-0" />
        <div class="p-2 viewmarkmodalheight">
          <div class="viewmark-testbox">
            <div class="viewmark-testbox-headtestname">Test name</div>
            <div class="viewmark-testbox-subtestname">
              {{ marksdetails.testName }}
            </div>
          </div>
          <div
            v-for="(item, index) in marksdetails.assessmentResponse"
            :key="index"
            class="viewmark-attempt-open-box mt-3"
          >
            <div
              class="
                viewmark-open-atmpt-box
                d-flex
                align-items-center
                justify-content-between
                pointer
              "
              @click="closemarks(index)"
            >
              <div class="viewmark-attempt-txt">
                Attempt {{ item.attemptNo }}
              </div>
              <div v-if="!item.viewdetails">
                <img
                  src="../../assets/img/viewmarksmodal/downarrow.svg"
                  alt=""
                />
              </div>
              <div v-else>
                <img src="../../assets/img/viewmarksmodal/uparrow.svg" alt="" />
              </div>
            </div>
            <div v-if="item.viewdetails" class="p-2">
              <div
                class="d-flex align-items-center justify-content-between m-2"
              >
                <div class="viewmark-date-txt">
                  Start Date : {{ item.startTime.slice(0, 10) | formatdate }}
                </div>
                <div class="viewmark-date-txt">
                  End Date : {{ item.endTime.slice(0, 10) | formatdate }}
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-between m-2"
              >
                <div class="">
                  <span class="viewmark-section-txt">Duration : </span
                  ><span class="viewmark-duration"
                    >&nbsp;{{ item.duration.slice(0, 7) }}</span
                  >
                </div>
                <div>
                  <span class="viewmark-section-txt">Result : </span>
                  <span
                    :class="
                      item.status == 'Fail'
                        ? 'viewmark-fail-txt'
                        : 'viewmark-pass-txt'
                    "
                    >{{ item.status }}</span
                  >
                </div>
              </div>
              <div class="viewmark-marks-container m-2">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="viewmark-section-txt">
                    <img
                      src="../../assets/img/viewmarksmodal/view result.svg"
                      class="mr-2"
                      alt=""
                    />
                    Marks
                  </div>
                  <div class="">
                    <span class="viewmark-section-txt">Total Marks : </span
                    ><span class="viewmark-duration"
                      >&nbsp;{{ item.marksScored }} /
                      {{ item.totalTestMarks }}</span
                    >
                  </div>
                </div>

                <hr />
                <div v-for="(sec, index) in item.sections" :key="index">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      mt-1
                    "
                  >
                    <div class="viewmark-section-txt">
                      {{ sec.sectionName }}
                    </div>
                    <div class="viewmark-mark-txt" style="color: #3f698e">
                      {{ sec.sectionMarksScored }} / {{ sec.sectionMarksTotal }}
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- ******************************* CANDIDATE PHOTO MODAL START************************************* -->
    <b-modal
      id="photo"
      size="lg"
      centered
      hide-footer
      hide-header
      :no-close-on-backdrop="true"
      style="width: 20%"
      @hidden="closePhoto"
    >
      <b-row style="margin-bottom: 1.5em">
        <b-col>
          <label class="caution-txt">IMAGE OF CANDIDATE TAKING INTERVIEW</label>
        </b-col>
        <b-col>
          <div @click="closePhoto" class="xMarkCancel" style="top: -25px">
            <img src="../../assets/cross-round.svg" alt="" />
          </div>
        </b-col>
      </b-row>
      <img :src="candidateCapture.candidateImage" style="width: 100%" alt="" />
    </b-modal>
    <!-- ******************************* CANDIDATE PHOTO MODAL END************************************* -->
  </div>
</template>

<script>
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import ViewFeedback from "../../controllers/JD/modals/ViewFeedback.vue";
import AllJobDetails from "../../controllers/panelLogin/modals/AllJobDetails";
import JobDetails from "../../controllers/panelLogin/modals/JobDetails";
import GiveFeedback from "../../controllers/panelLogin/modals/GiveFeedback.vue";
import LastRoundFeedback from "../../controllers/panelLogin/modals/LastRoundFeedback";
import { downloadFeedback } from "../../utils/download.js";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom";

import { NumbersOnly } from "../../controllers/Candidate/helpers";
import History from "../../controllers/JD/modals/History.vue";
import { mapGetters } from "vuex";
import commonFunc from "../../components/mixin/commonFunctions.js";

// import { assignfilledvalues } from "../../controllers/panelLogin/helpers.js";
import {
  exportResume,
  history,
  getPanelJdDetails,
  getallfeedbackforms,
} from "../../controllers/panelLogin/asynchronous.js";
import {
  getPanelCandidate,
  getAllPanelCandidate,
  getCustomerFields,
  getmarksdetails,
  getScheduledInterview,
} from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { getValidations } from "../../controllers/panelLogin/validations";

import { isPhoto } from "../../utils/checkFiletype.js";
import screeningMixin from "./screeningMixin.js";

export default {
  name: "PanelCand",
  components: {
    SelectCustom,
    Spinner,
    ViewFeedback,
    AllJobDetails,
    GiveFeedback,
    LastRoundFeedback,
    PageInput,
    MultiSelectCustom,
    JobDetails,
    // PreviewFeedback,
    History,
  },

  data() {
    return {
      basicArray: [],
      advanceArray: [],
      showBasicDetailsJD: false,
      showAllDetailsJD: false,
      showModal: false,
      evalDate: "",
      panelName: "",
      selectedText: "", // Variable to store selected text
      selectedValue: [],
      interviewRounds: [],
      collapsedIndexes: [],
      customFieldsArray: [],
      passData: {},
      ipmodal: false,
      interviewObject: {},
      lastRoundfeedback: false,
      uploadcandheight: "",
      timer: null,
      checkMedia: false,
      fileCheck: false,
      loopvar2: 3,
      juscount: 10,
      filtercount: 0,
      allDetailDropDowns: "openBasic",
      requiredPanel: null,
      intIndex: null,
      loopvar: 4,
      txt: "hello",
      loopVar: 6,
      jdDetailsType: null,
      image: [],
      rounds: [
        {
          text: "1",
          value: 1,
        },
        {
          text: "F",
          value: "F",
        },
      ],
      feedbackstatus: null,
      goToPage: null,
      activeIndex: null,
      total: 0,
      totalques: 0,
      currentPage: 1,
      pageCount: 10,
      viewfeedback: false,
      isFailed: false,
      checkimage: false,
      interviewCandidate: "",
      candidateCapture: "",
      LoaderStatus: false,
      showSpinner: false,
      showfeedbackSpinner: false,
      showfiltercard: false,
      screenshotname: "",
      candidateID: "",
      selectedCandidate: null,
      jobID: "",
      pageStart: "",
      pageEnd: "",
      searchname: "",
      statusValue: "createdAt",
      sortByValue: false,
      recruiterRemarks: "",
      nxtpg: "0",
      feedbackValue: "false",
      feedbackform: {},
      feedbackHistory: [],
      jobname: "",
      skills: [],
      sourceof: [],
      areaofexp: [],
      marksdetails: {},
      filledfdbckform: {},
      individualMark: {},
      panelJdDetails: {},
      viewScreenshot: "",
      interviewResponse: {},

      candidateDetails: {
        evalDate: "",

        experience: "",

        modeOfInterview: "",

        name: "",

        panel: "",
      },

      feedback: {
        interviewID: "",
        name: "",
        recommendation: "",
        panelName: "",
        processedBy: "Panel",
        customFeedback: {},
        recOption: "",
      },
      allpaneldata: [],
      feedbackdata: [],
      Panelcandidatedetails: [],
      tabIndex: 0,
    };
  },

  validations() {
    return getValidations(this);
  },
  props: {
    isLaptop: Boolean,
  },
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
    // fn used so that the strings are shown as strings and not as array
    fnName: function (value) {
      if (value.length <= 3) {
        return value.slice(0, 3) + " ";
      } else {
        return value.slice(0, 3) + "...";
      }
    },
  },

  mixins: [toast, screeningMixin, commonFunc],
  computed: {
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    shouldShowProvideFeedback() {
      return (
        (this.tabIndex == 1 &&
          this.feebackProvideCandidate.length != 0 &&
          this.filtercount == 0) ||
        (this.tabIndex == 1 && this.filtercount != 0)
      );
    },
    shouldShowScheduledFeedback() {
      return (
        (this.tabIndex == 0 &&
          this.feebackScheduledCandidate.length != 0 &&
          this.filtercount == 0) ||
        (this.tabIndex == 0 && this.filtercount != 0)
      );
    },
    shouldShowScreenTab() {
      return (
        (this.tabIndex == 2 &&
          this.screeningCandidates.length != 0 &&
          this.screenFiltercount == 0) ||
        (this.tabIndex == 2 && this.screenFiltercount != 0)
      );
    },
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters({ roles: "roles" }),
    ...mapGetters("userVUEX", {
      userInfo: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    transformedRounds() {
      return this.interviewRounds.map((item) => {
        return {
          key: item,
          label: item,
        };
      });
    },
    checkPanel() {
      return (
        this.requiredPanel === "allpanelist" ||
        this.requiredPanel === "nopanelist" ||
        (this.requiredPanel === "partpanelist" &&
          this.panelJdDetails.assignedPanelist.length > 0)
      );
    },
    itemId() {
      return (index) => `item-${index}`;
    },
    // To check if it does not contain an alphabet or zero
    iscontainsNumber() {
      let number = this.goToPage;
      if (this.tabIndex === 2) {
        number = this.goToScreen;
      }
      return /^[1-9]\d*$/.test(number);
    },
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },

    currentDate() {
      // Create a new Date object to get the current date and time.
      const date = new Date();

      // Extract the day, month, and year components from the Date object.
      let day = date.getDate(); // Get the day of the month (1-31).
      let month = date.getMonth() + 1; // Get the month (0-11), add 1 to make it (1-12).
      let year = date.getFullYear(); // Get the current year (e.g., 2023).

      // Return the formatted date as a string in the format 'day-month-year'.
      return `${day}-${month}-${year}`;
    },
    feebackProvideCandidate() {
      const filterData = this.allpaneldata.filter((data) => {
        return data.feedback;
      });
      return filterData;
    },

    feebackScheduledCandidate() {
      const filterData = this.allpaneldata.filter((data) => {
        return !data.feedback;
      });
      return filterData;
    },
  },
  watch: {
    tabIndex(newValue) {
      let status;
      // Map the tabIndex value to the corresponding status
      switch (newValue) {
        case 0:
          status = "scheduled";
          break;
        case 1:
          status = "feedbackprovided";
          break;
        case 2:
          status = "screening";
          break;
        default:
          status = "scheduled";
          break;
      }
      // Update the route with the new status query parameter
      this.$router.push({
        name: "PanelLogin",
        query: {
          status: status,
        },
      });
    },
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.currentPage = 1;
          if (this.tabIndex === 2) {
            this.fetchScreeningData();
          } else {
            this.getAllPanelCandidate();
          }
        }
      }
    },
  },
  mounted() {
    document.body.addEventListener("click", this.handleClose);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleClose);
  },
  created() {
    this.setTabIndex();
    this.getCustomFieldsArray();
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    if (this.$route.query.history) {
      this.history(this.storedData.candidate);
    } else if (this.$route.query.givefeed) {
      this.getfeedbackforms(this.storedData.candidate);
    }
  },
  methods: {
    storeCandidateData() {
      let data = {
        candidate: this.selectedCandidate,
        status: this.$route.query.status,
      };
      this.$store.commit("jobDescriptionVUEX/setSelectedCandidate", data);
    },
    handleClose(event) {
      if (!event) return;
      const dropdowns = document.getElementsByClassName(
        "selectCustom-dropdown-innerContent"
      );

      let dropdownContainsTarget = false;
      for (let i = 0; i < dropdowns.length; i++) {
        if (dropdowns[i].contains(event.target)) {
          dropdownContainsTarget = true;
          break;
        }
      }
      if (
        this.$refs.filtercard &&
        !this.$refs.filtercard.contains(event.target) &&
        !this.$refs.filterButton.contains(event.target) &&
        !dropdownContainsTarget
      ) {
        this.showfiltercard = false;
      }
    },
    hideAllJobDetailsModal() {
      this.showAllDetailsJD = false;
      this.$bvModal.hide("viewalljddetails");
    },
    hideBasicJobDetailsModal() {
      this.showBasicDetailsJD = false;
      this.$bvModal.hide("jd-detail");
    },
    navigateToLink(candidate) {
      if (candidate.meetingLink) {
        try {
          const url = new URL(candidate.meetingLink);
          window.open(url.href, "_blank");
        } catch (e) {
          window.open("http://" + candidate.meetingLink, "_blank");
        }
      } else {
        console.error("Meeting link not available");
      }
    },

    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      const day = days[date.getDay()];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = String(date.getMinutes()).padStart(2, "0");
      const ampm = hour >= 12 ? "PM" : "AM";
      const formattedHour = hour % 12 || 12;

      return `${formattedHour}:${minute} ${ampm} ${day}, ${month} ${date.getDate()}, ${year}`;
    },

    calculateRows(text) {
      const lineCount = text.split("\n").length;
      // Set a minimum number of rows to avoid the textarea collapsing to nothing
      const minRows = 1;
      return Math.max(minRows, lineCount);
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    downloadImage(url) {
      downloadFeedback(url);
    },
    downloadFeedback(url) {
      downloadFeedback(url);
    },

    setTabIndex() {
      switch (this.$route.query.status) {
        case "scheduled":
          this.tabIndex = 0;
          this.feedbackValue = "false";
          break;
        case "feedbackprovided":
          this.tabIndex = 1;
          this.feedbackValue = "true";
          break;
        case "screening":
          this.tabIndex = 2;
          break;
        default:
          this.tabIndex = 0;
          this.feedbackValue = "false";
      }
      if (this.tabIndex !== 2) this.getAllPanelCandidate();
      else this.fetchScreeningData();

      this.statusValue = "createdAt";
      this.sortByValue = false;
      this.goToPage = null;
      this.currentPage = 1;
    },

    closejdDetail() {
      this.$bvModal.hide("jd-detail");
      this.panelJdDetails = {};
    },
    hideFeedbackhistory() {
      this.$bvModal.hide("history");
      this.showModal = false;
      this.selectedCandidate = null;
      setTimeout(() => {
        this.feedbackHistory = [];
      }, 100);
    },
    // download resume api
    async exportResume(data) {
      this.LoaderStatus = true;
      await exportResume(data);
      this.LoaderStatus = false;
    },

    closemarks(index) {
      this.marksdetails.assessmentResponse[index].viewdetails =
        !this.marksdetails.assessmentResponse[index].viewdetails;
      this.$forceUpdate();
    },

    async getPanelJdDetails(data) {
      await getPanelJdDetails(data, this);
    },

    isPhoto,

    closePhoto() {
      this.$bvModal.hide("photo");
    },
    viewImage(data) {
      this.$bvModal.show("photo");
      this.candidateCapture = data;
    },
    async assignMarks(data) {
      this.individualMark = data;
      const res = await getmarksdetails(this.individualMark.interviewID);
      if (res.status == 200) {
        this.marksdetails = res.data.data;
        this.marksdetails.assessmentResponse.forEach((value, index) => {
          if (index == 0) {
            value.viewdetails = true;
          } else {
            value.viewdetails = false;
          }
        });
      }
      this.$bvModal.show("totalmark");
    },

    async history(data) {
      this.showModal = true;
      this.showSpinner = true;
      this.selectedCandidate = data;
      this.$bvModal.show("history");
      await history(data, this);
      this.showSpinner = false;
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getAllPanelCandidate();
    },
    clearfilter() {
      this.jobname = "";
      this.skills = [];
      this.selectedValue = [];

      if (this.filtercount != 0) {
        this.statusValue = "createdAt";
        this.getAllPanelCandidate();
      }
      this.filtercount = 0;
    },
    applyFilterCard() {
      this.statusValue = "";
      this.showfiltercard = false;
      this.filtercount = 0;
      if (
        this.sourceof.length !== 0 ||
        this.areaofexp.length !== 0 ||
        this.createdAt != ""
      ) {
        this.filtercount++;
      }
      this.getAllPanelCandidate();
    },
    commenterror(inputindex) {
      let checkmark = this.feedbackform.skills[inputindex].mark;

      const test = /^[a-zA-Z0-9]$/.test(checkmark);
      if (!test || this.feedbackform.skills[inputindex].mark == "") {
        this.feedbackform.skills[inputindex].markerror = true;
      } else {
        this.feedbackform.skills[inputindex].markerror = false;
      }
      if (this.feedbackform.skills[inputindex].comments == "") {
        this.feedbackform.skills[inputindex].commenterror = true;
      } else {
        this.feedbackform.skills[inputindex].commenterror = false;
      }
      this.$forceUpdate();
    },
    getpaneldata() {
      getPanelCandidate()
        .then((res) => {
          if (res.status == 200) {
            this.allpaneldata = res.data.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    searchPanel() {
      this.currentPage = 1;
      clearTimeout(this.timer);
      this.getAllPanelCandidate();
    },
    // Get Pagination API
    getAllPanelCandidate() {
      this.LoaderStatus = true;
      let payload = {
        page: this.currentPage - 1,
        count: this.pageCount,
        sortBy: {
          column: this.statusValue,
          order: this.sortByValue,
        },
        filters: {
          feedback: this.feedbackValue,
          jobName: this.jobname,
          skills: this.skills,
          // round: this.selectedValue,
          ...(this.selectedValue.length != 0 && { round: this.selectedValue }),
        },

        searchQuery: this.searchQuery,
      };

      getAllPanelCandidate(payload)
        .then((res) => {
          if (res.status == 200) {
            this.LoaderStatus = false;
            if (this.filtercount == 0) {
              this.interviewRounds = res.data.data.rounds;
            }
            this.allpaneldata = res.data.data.data;
            this.nxtpg = res.data.data.nextPage;
            this.prevpg = res.data.data.prevPage;
            this.pageStart = res.data.data.pageStart;
            this.pageEnd = res.data.data.pageEnd;
            this.total = res.data.data.total;
          }
          const element = document.getElementById("0top");
          element.scrollIntoView({
            behavior: "smooth",
          });
          const ele1 = document.getElementById("0top1");
          ele1.scrollIntoView({
            behavior: "smooth",
          });
        })
        .catch((err) => {
          throw err;
        });
    },

    // GO TO ANY PAGE
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getAllPanelCandidate();
    },
    closefiltercard() {
      this.showfiltercard = false;
    },
    tagValidatorskill(tag) {
      let skill_list = this.sourceof.map((s) => s.toLowerCase());
      return !skill_list.includes(tag.toLowerCase());
    },
    async getfeedbackforms(data) {
      this.selectedCandidate = data;
      await this.getScheduledProcess(data);
      await getallfeedbackforms(data, this);
    },
    async getScheduledProcess(data) {
      const res = await getScheduledInterview(data.interviewID);
      if (res.status == 200) {
        this.interviewObject = res.data.data;
      }
    },
    async getCustomFieldsArray() {
      let parentID = 1;
      let response = await getCustomerFields({ parentID });
      if (response.status == 200) {
        this.customFieldsArray = response.data.data.fields;
        this.customFieldsArray.forEach((obj) => {
          if (obj.category === 1 || obj.category === null) {
            this.basicArray.push(obj); // Push objects with category value 1 into category1Array
          } else if (obj.category === 2) {
            this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
          }
        });
      }
    },
  },
};
</script>

<style>
.tabbed.newpanellogintabs ul li a {
  width: 215px;
}
.test-name {
  padding: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  box-shadow: 0px 4px 20px rgb(196 196 196 / 50%);
  border-radius: 8px;
}

.plogin .tabbed ul li a:before {
  top: 0px;
  height: 105%;
  z-index: 1;
}
.plogin .nav-tabs {
  border-bottom: none;
}
.plogin .tabbed ul li a.active:before {
  background: #72738e;
  border-top: 1px solid #72738e;
}
.interskilkls-head {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  word-break: break-all;
}
.remarks {
  font-weight: 400;
  font-size: 12px;
  color: #6d6d6d;
}
.remarks-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}
input[type="file"] {
  opacity: 0;
}
.inputimage-false {
  position: absolute;
  width: 100%;
  height: 50%;
  left: 0;
  top: 0;
}
.inputimage {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.panel-basicDetails {
  height: calc(100vh - 450px);
  overflow: auto;
  overflow-x: hidden;
}
.selected-dash-table tbody {
  display: block;
  border-radius: 5px;
  overflow-x: auto;
  height: calc(100vh - 430px);
  margin-top: 5px;
  width: calc(100% + 15px);
}
.currentlydisp {
  font-weight: 400;
  font-size: 14px;
  color: #696969;
}
.currentlydispmsg {
  color: #529433;
  font-weight: 600;
  font-size: 14px;
}
.viewfeedbackcont {
  cursor: pointer;
  padding: 10px 20px;
}
.viewfeedback {
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
}
.givefeedbckbtn {
  background: #72738e;
  border: 1px solid #72738e;
  box-sizing: border-box;
  border-radius: 5px;
  color: white;
  font-weight: 400;
  font-size: 13px;
  cursor: pointer;
  padding: 10px 20px;
  text-align: center;
}
.disable-givefeedbckbtn {
  background: rgba(114, 115, 142, 0.15);

  box-sizing: border-box;
  border-radius: 5px;
  color: #72738e;
  font-weight: 500;
  font-size: 13px;

  padding: 10px 20px;
  text-align: center;
}
.disablegivefeedbckbtn {
  background: #c4c4c4;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 5px;
  color: white;
  font-weight: 400;
  font-size: 13px;
  padding: 10px 20px;
  text-align: center;
}
.selected-table-cards:hover {
  background: #e7e8f5;
}

.fdbck-right-head-container {
  padding: 10px 15px;
  font-weight: 600;
  font-size: 14px;
  color: #ffffff;
  margin: 5px;
  background: rgba(10, 86, 200, 0.5);
  border-radius: 2px;
}

.fdbck-right-detail-container {
  background: #ffffff;
  border: 0.7px solid #e5e5e5;
  box-sizing: border-box;
  box-shadow: 0px 1px 20px rgba(86, 86, 86, 0.2);
  border-radius: 5px;

  margin: 5px 0px;
  min-height: auto;
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.b-rating.disabled {
  background-color: unset;
  color: #6c757d;
}
.viewfdbck-image {
  height: 300px;
  width: 430px;
}
.custom-radio
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #72738e;
}

.feedbk-round-head-jd {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.pc-jd-modal-height {
  height: calc(100vh - 245px);
  overflow: auto;
}

.pc-grey-back {
  background: #e8e5e5;
  border-radius: 4px;
  width: fit-content;
  padding: 5px 10px;
}
/* new css fr give fdbck */
.plogin-skillcards {
  background: #ffffff;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 15px;
}
.plogon-skillcard-heading {
  font-weight: 500;
  font-size: 16px;
  color: #696969;
}
.plogon-skillcard-subheading {
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}
.plogin-fdbck-formcontainer {
  background: #ffffff;
  border: 0.5px solid #cbcbcb;
  border-radius: 0 0 8px 8px;
  padding: 10px;
  min-height: auto;
  max-height: calc(100vh - 220px);
}
.plogin-fdbckname-box {
  background: #e8f0fe;
  border: 1px solid #eaeaea;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 10px 10px 0px 0px;
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}
.plogin-fdbck-formcontainer input::placeholder {
  font-weight: 400;
  font-size: 12px;
  color: #c4c4c4;
}
.panel-text-break {
  display: block;
  width: 150px;
  word-wrap: break-word;
}

.plogin-fdbck-formcontainer textarea::placeholder {
  font-weight: 400;
  font-size: 12px;
  color: #c4c4c4;
}
.panel-nofeedback-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}
.jd-max-size {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #72738e;
}
.kanban-main-upload {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #72738e;
}

.panelinputfile .custom-file label {
  text-align: center;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2372738EFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 13px;
  border: unset;
}
.panelinputfile .custom-file-label::after {
  display: none !important;
  cursor: pointer;
}
.custom-file-label span {
  display: none !important;
}
.panelinputfile input {
  height: 100%;
  z-index: 656 !important;
  cursor: pointer;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: unset;
  box-shadow: unset;
}
.custom-file-input:lang(en) ~ .custom-file-label:after {
  cursor: pointer;
}

input#file-upload-button {
  cursor: pointer;
}

/* table design changes  */
.scheduled-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 256px);
  overflow-x: auto;
  overflow-y: hidden;
}

.panelCand-gridDynamicColor {
  width: 4px;
  height: 52px;
  border-radius: 2px;
  position: absolute;
  left: 3px;
  top: -17px;
  background: #72738e;
}

.approval-table-row-feedbackProvided {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fafafa;
  box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #696969;
  padding: 20px 0px;
  margin: 6px 0px;
}

.approval-table-row-feedbackProvided:hover {
  background: #e7e8f5;
}

.approval-table-row-show-all {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fafafa;
  box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #696969;
  margin: 6px 0px;
  height: 60px;
}

.approval-table-row-show-all:hover {
  background: #e7e8f5;
}
.panLog-main-class {
  height: calc(100vh - 167px);
  overflow: auto;
  margin-top: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 10px;
}
.pan-log-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-weight: 700;
  font-size: 16px;
  color: #20639b !important;
  font-family: "lato", sans-serif;
}
.pan-log-tabs a {
  color: #000000 !important;
  font-weight: 600;
  font-size: 16px;
  font-family: "lato", sans-serif;
  line-height: 21px;
}
.pan-log-tabs li {
  text-align: center;
  margin-right: 8px;
}
.pan-log-tabs .nav-tabs .nav-link {
  border: unset;
}

.pan-log-tabs .nav-tabs {
  border-bottom: 1px solid #d9d9d9;
  padding-left: 20px;
}
.pan-log-tabs .nav-link {
  display: block;
  padding: 17px 13px;
}
.pan-log-tabs .nav-tabs .nav-link.active {
  position: relative;
  /* border-bottom: 4px solid #20639B;
  box-shadow: 0px 4px 8px 0px #0000002B; */
}
.pan-log-tab {
  position: absolute;
  border-bottom: 4px solid #20639b;
  box-shadow: 0px 4px 8px 0px #0000002b;
  width: 100px;
  height: 4px;
  border-radius: 25px 25px 6px 6px;
  top: -8px;
  left: 22px;
}
.pan-log-fp-tab {
  position: absolute;
  border-bottom: 4px solid #20639b;
  box-shadow: 0px 4px 8px 0px #0000002b;
  width: 162px;
  height: 4px;
  border-radius: 25px 25px 6px 6px;
  top: -8px;
  left: 127px;
}
.gridgreencolorDynamic-user {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  background: #20639b;
  top: 2px;
  left: 3px;
}
.pl-40 {
  padding-left: 40px;
}
.qb-gotopage-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height */

  color: #20639b;
}
.qb-pagination-num {
  width: 39.72px;
  height: 23px;
  font-size: 12px;

  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 5px;
}
.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}
.page_text .page-link {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;

  color: #20639b;
}
.page_text .page-item.active .page-link {
  width: 19.86px;
  height: 20px;
  color: #ffffff;
  padding: 3px;
  background: #20639b;
  border-radius: 3px;
}
.fil-btn-pos {
  position: absolute;
  top: -43px;
  right: 0px;
}
.addpan .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 10px 5px 10px;
  gap: 10px;

  /* position: absolute;
left: 87.22%;
right: 3.33%;
top: 10.92%;
bottom: 85.22%; */

  background: #20639b;
  border-radius: 40px;
}
.addpan .btn-secondary:hover {
  color: var(--bg-white);
  background-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.addpan .btn-secondary:not(:disabled):not(.disabled):active,
.addpan .btn-secondary:not(:disabled):not(.disabled).active,
.addpan .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #20639b;
  border-color: #20639b;
}
.addpantxt {
  font-family: "Montserrat", sans-serif, sans-serif;
  font-weight: 600;
  font-size: 13px;
  /* identical to box height */
  display: flex;
  align-items: center;

  color: #ffffff;
}

.filter-fields {
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
}
.notfoundimg {
  font-family: "Lato";
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}

/* panel candidate new table design fixes starts */
.new-panelCand-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 233px);
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px;
}

.new-panelCand-table-head {
  min-width: 1410px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.new-panelCand-table-body {
  min-width: 1410px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 340px);
}

.new-panelCand-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  height: 50px;
  margin: 10px 0px;
}

.new-panelCand-table-row:hover {
  background: #e7e8f5;
}

.new-panelCand-admin-paginaTion-new {
  min-width: 1410px;
  max-width: 100%;
  padding: 5px 10px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
  border-radius: 0px 0px 5px 5px;
  background: #fcfcfc;
  z-index: 1;
}
/* panel candidate new table design fixes ends */

.resume-screening-table-row {
  max-width: 100%;
}
.resumescreening-table-head {
  padding: 10px 5px 10px 0;
  margin: 10px 10px 0 10px;
}
.overflow-xh-ya {
  overflow-x: hidden;
  overflow-y: auto;
}
.resume-screening-table-body {
  margin: 0 10px 0 10px;
}
</style>
